let ready = null;

export function sessionReady() {

    ready ??= jQuery.post(ajaxURL, { action: 'mediatheme_session' }).then(function (response) {
        if (!response.success) return;

        ajaxNonce = response.data.nonce;
        jQuery('.header__wc-cart-count').text(response.data.count);
    });

    return ready;

}

export default function session() {

    sessionReady();

}
